export default __webpack_public_path__ + "static/media/FinishMaple.23bfda12.png";